// v10/src/hooks/useBadge.js
// Limpia el badge del ícono de la PWA cuando el usuario está en la app

import { useEffect } from 'react';

const useBadge = () => {
  useEffect(() => {
    const clearBadge = () => {
      if (navigator.clearAppBadge) {
        navigator.clearAppBadge().catch(() => {});
      }
    };

    // Limpiar al abrir la app
    clearBadge();

    // Limpiar cada vez que el usuario vuelve al tab
    const handleVisibility = () => {
      if (!document.hidden) clearBadge();
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, []);
};

export default useBadge;
